import { useContext } from "react";
import { ManualOfflineContext } from "./ManualOfflineContext";
import { OnlineStatusContext } from "./OnlineStatusContext";

const OnlineWrapper = ({ children }) => {
  const { manualOffline } = useContext(ManualOfflineContext);
  const { isOnline } = useContext(OnlineStatusContext);

  return !manualOffline && isOnline && children;
};

export default OnlineWrapper;
